import cn from 'classnames';
import { useWindowWidth } from 'src/hooks/useWindowWidth';

import s from './List.module.scss';

interface ListItemProps {
  title: string;
  text: string;
  number: number;
  withoutNumbers?: boolean;
}

function ListItem({ number, title, text, withoutNumbers }: ListItemProps) {
  return (
    <div className={cn(s.item, 'c-constructor__list-item')}>
      {!withoutNumbers && (
        <div className={cn(s.itemNumber, 'c-constructor__list-item-number')}>
          {number}
        </div>
      )}
      <h3 className={cn(s.itemTitle, 'c-constructor__list-item-title')}>
        {title}
      </h3>
      <div
        className={cn(s.itemText, 'c-constructor__list-item-text')}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
}

interface ListProps {
  title: string;
  items: Omit<ListItemProps, 'number'>[];
  withoutNumbers?: boolean;
  shapeImage?: string;
  subtitle?: string;
}

export function List({
  title,
  subtitle,
  items,
  withoutNumbers,
  shapeImage,
}: ListProps) {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  const shape = shapeImage
    ? shapeImage
    : 'https://cdn.cloud.ru/backend/images/cloud-backup/block-shape.png';

  return (
    <section className={cn(s.root, 'c-constructor__list')}>
      <div className={s.wrapper}>
        {subtitle && (
          <h3
            className={cn(s.subtitle, 'c-constructor__list-subtitle')}
            data-qa="section_subtitle"
          >
            {subtitle}
          </h3>
        )}
        <h2
          className={cn(s.title, 'c-constructor__list-title')}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={cn(s.items, 'c-constructor__list-items')}>
          {items.map(({ title, text }, index) => (
            <ListItem
              title={title}
              text={text}
              withoutNumbers={withoutNumbers}
              number={index + 1}
              key={index}
            />
          ))}
        </div>
        {windowWidth && windowWidth > MD && (
          <img
            src={shape}
            alt="shape abstraction"
            className={cn(s.shape, 'c-constructor__list-shape')}
            data-qa="shape image"
            width={1020}
            height={747}
          />
        )}
      </div>
    </section>
  );
}
